export default {
    cro_1: 'Adenocarcinoma (Esophageal cancer)',
    cro_2: 'Other (Esophageal cancer)',
    cro_3: 'Squamous cell carcinoma (Esophageal cancer)',
    cro_4: 'Unspecified carcinoma (Esophageal cancer)',
    cro_5: 'Cholangiocarcinoma (Liver cancer)',
    cro_6: 'Hemangiosarcoma (Liver cancer)',
    cro_7: 'Hepatocellular carcinoma (Liver cancer)',
    cro_8: 'Other (Liver cancer)',
    cro_9: 'Unspecified carcinoma (Liver cancer)',
    cro_10: 'Adenocarcinoma (Tracheal, bronchus, and lung cancer)',
    cro_11: 'Large cell carcinoma (Tracheal, bronchus, and lung cancer)',
    cro_12: 'Other (Tracheal, bronchus, and lung cancer)',
    cro_13: 'Small cell carcinoma (Tracheal, bronchus, and lung cancer)',
    cro_14: 'Squamous cell carcinoma (Tracheal, bronchus, and lung cancer)',
    cro_15: 'Adenocarcinoma (Cervical cancer)',
    cro_16: 'Other (Cervical cancer)',
    cro_17: 'Squamous cell carcinoma (Cervical cancer)',
    cro_18: 'Unspecified carcinoma (Cervical cancer)',
    cro_19: 'Adenocarcinoma (Uterine cancer)',
    cro_20: 'Other (Uterine cancer)',
    cro_21: 'Unspecified carcinoma (Uterine cancer)',
    cro_22: 'Adenocarcinoma (Colon and rectum cancer)',
    cro_23: 'Melanoma (Colon and rectum cancer)',
    cro_24: 'Other (Colon and rectum cancer)',
    cro_25: 'Squamous cell carcinoma (Colon and rectum cancer)',
    cro_26: 'Unspecified carcinoma (Colon and rectum cancer)',
    cro_27: 'Adenocarcinoma (Ovarian cancer)',
    cro_28: 'Clear cell carcinoma (Ovarian cancer)',
    cro_29: 'Endometrioid carcinoma (Ovarian cancer)',
    cro_30: 'Germ cell tumour (Ovarian cancer)',
    cro_31: 'Mucinous carcinoma (Ovarian cancer)',
    cro_32: 'Other (Ovarian cancer)',
    cro_33: 'Serous carcinoma (Ovarian cancer)',
    cro_34: 'Sex cord-stromal tumour (Ovarian cancer)',
    cro_35: 'Unspecified carcinoma (Ovarian cancer)',
    cro_36: 'Non-seminomatous germ cell tumours (Testicular cancer)',
    cro_37: 'Other (Testicular cancer)',
    cro_38: 'Seminoma (Testicular cancer)',
    cro_39: 'Spermatocytic seminoma (Testicular cancer)',
    cro_40: 'Adenocarcinoma (Bladder cancer)',
    cro_41: 'Other (Bladder cancer)',
    cro_42: 'Squamous cell carcinoma (Bladder cancer)',
    cro_43: 'Transitional cell carcinoma (Bladder cancer)',
    cro_44: 'Unspecified carcinoma (Bladder cancer)',
    cro_45: 'Astrocytic tumours (Brain and central nervous system cancer)',
    cro_46: 'Ependymal tumours (Brain and central nervous system cancer)',
    cro_47: 'Gliomas of uncertain origin (Brain and central nervous system cancer)',
    cro_48: 'Medulloblastoma (Brain and central nervous system cancer)',
    cro_49: 'Oligodendroglial tumours and mixed gliomas (Brain and central nervous system cancer)',
    cro_50: 'Other (Brain and central nervous system cancer)',
    cro_51: 'Anaplastic carcinoma (Thyroid cancer)',
    cro_52: 'Follicular carcinoma (Thyroid cancer)',
    cro_53: 'Medullary carcinoma (Thyroid cancer)',
    cro_54: 'Other (Thyroid cancer)',
    cro_55: 'Papillary carcinoma (Thyroid cancer)',
    cro_56: 'Unspecified carcinoma (Thyroid cancer)',
    cro_57: 'Melanoma (Eye cancer)',
    cro_58: 'Other (Eye cancer)',
    cro_59: 'Squamous cell carcinoma (Eye cancer)',
    cro_60: 'Unspecified carcinoma (Eye cancer)',
    cro_61: 'Chondrosarcoma (Malignant neoplasm of bone and articular cartilage)',
    cro_62: 'Ewing sarcoma (Malignant neoplasm of bone and articular cartilage)',
    cro_63: 'Osteosarcoma (Malignant neoplasm of bone and articular cartilage)',
    cro_64: 'Other (Malignant neoplasm of bone and articular cartilage)',
    cro_65: 'Unspecified sarcoma (Malignant neoplasm of bone and articular cartilage)',
    cro_66: 'HR+/HER2+ (Breast cancer)',
    cro_67: 'HR-/HER2+ (Breast cancer)',
    cro_68: 'HR+/HER2- (Breast cancer)',
    cro_69: 'HR-/HER2- (Breast cancer)',
    cro_70: 'Diffuse astrocytoma and anaplastic astrocytoma (Brain and central nervous system cancer)',
    cro_71: 'Glioblastoma (Brain and central nervous system cancer)',
    cro_72: 'Embryonal tumors (Brain and central nervous system cancer)',
    cro_73: 'Meningiomas (Brain and central nervous system cancer)',
    cro_74: 'Other Glioma (Brain and central nervous system cancer)',
    cro_75: 'Other Tumors (Brain and central nervous system cancer)',
    cro_50001: 'Atrial fibrillation and flutter',
    cro_50002: 'Atrial fibrillation (Atrial fibrillation and flutter)',
    cro_50003: 'Atrial flutter (Atrial fibrillation and flutter)',
    cro_50004: 'Atrial fibrillation plus flutter (Atrial fibrillation and flutter)',
    cro_32901: 'Otitis media',
    cro_32902: 'Acute mastoiditis without complications (Otitis media)',
    cro_32903: 'Subperiosteal abscess of mastoid (Otitis media)',
    cro_32904: 'Acute mastoiditis with other complications (Otitis media)',
    cro_32905: 'Chronic mastoiditis (Otitis media)',
    cro_32906: 'Acute petrositis (Otitis media)',
    cro_32907: 'Postauricular fistula (Otitis media)',
    cro_32908: 'Other and unspecified otitis media (Otitis media)',
    cro_32909: 'Chronic petrositis (Otitis media)',
    cro_42601: 'Tracheal, bronchus, and lung cancer',
    cro_42602:
        'Malignant neoplasm of upper lobe, bronchus or lung (Tracheal, bronchus, and lung cancer)',
    cro_42603:
        'Malignant neoplasm of lower lobe, bronchus or lung (Tracheal, bronchus, and lung cancer)',
    cro_42604:
        'Malignant neoplasm of overlapping sites, bronchus or lung (Tracheal, bronchus, and lung cancer)',
    cro_42605: 'Malignant neoplasm of trachea (Tracheal, bronchus, and lung cancer)',
    cro_42606:
        'Malignant neoplasm of middle lobe, bronchus or lung (Tracheal, bronchus, and lung cancer)',
    cro_42607:
        'Malignant neoplasm of unspecified part of bronchus or lung (Tracheal, bronchus, and lung cancer)',
    cro_42608: 'Malignant neoplasm of main bronchus (Tracheal, bronchus, and lung cancer)',
    cro_44101: 'Colon and rectum cancer',
    cro_44102: 'Malignant neoplasm of rectum (Colon and rectum cancer)',
    cro_44103: 'Other neoplasms of colon an rectum (Colon and rectum cancer)',
    cro_44104: 'Malignant neoplasm of rectosigmoid junction (Colon and rectum cancer)',
    cro_44105: 'Malignant neoplasm of colon (Colon and rectum cancer)',
    cro_47701: 'Brain and central nervous system cancer',
    cro_47702: 'Malignant neoplasm of brain (Brain and central nervous system cancer)',
    cro_47703: 'Malignant neoplasm of meninges (Brain and central nervous system cancer)',
    cro_47704:
        'Malignant neoplasm of spinal cord, cranial nerves and other parts of central nervous system (Brain and central nervous system cancer)',
    cro_47705:
        'Other malignant neoplasms of brain and central nervous system (Brain and central nervous system cancer)',
    cro_48401: 'Hodgkin lymphoma',
    cro_48402: 'Nodular lymphocyte predominant Hodgkin lymphoma (Hodgkin lymphoma)',
    cro_48403: 'Nodular sclerosis Hodgkin lymphoma (Hodgkin lymphoma)',
    cro_48404: 'Mixed cellularity Hodgkin lymphoma (Hodgkin lymphoma)',
    cro_48405: 'Lymphocyte depleted Hodgkin lymphoma (Hodgkin lymphoma)',
    cro_48406: 'Other and unspecifed hodgkin lymphoma (Hodgkin lymphoma)',
    cro_48407: 'Lymphocyte-rich Hodgkin lymphoma (Hodgkin lymphoma)',
    cro_48501: 'Non-Hodgkin lymphoma',
    cro_48502: 'Follicular lymphoma (Non-Hodgkin lymphoma)',
    cro_48503: 'Small cell B-cell lymphoma (Non-Hodgkin lymphoma)',
    cro_48504: 'Diffuse large B-cell lymphoma (Non-Hodgkin lymphoma)',
    cro_48505: 'Lymphoblastic (diffuse) lymphoma (Non-Hodgkin lymphoma)',
    cro_48506: 'Burkitt lymphoma (Non-Hodgkin lymphoma)',
    cro_48507: 'Mature T/NK-cell lymphomas (Non-Hodgkin lymphoma)',
    cro_48508: 'Mantle cell lymphoma (Non-Hodgkin lymphoma)',
    cro_48509: 'Other and unspecified non-hodgkin lymphoma (Non-Hodgkin lymphoma)',
    cro_48601: 'Multiple myeloma',
    cro_48602: 'Solitary plasmacytoma (Multiple myeloma)',
    cro_48603: 'Plasma cell leukemia (Multiple myeloma)',
    cro_48604: 'Multiple myeloma (specific) (Multiple myeloma)',
    cro_48605:
        'Malignant immunoproliferative diseases and certain other B-cell lymphomas (Multiple myeloma)',
    cro_48606: 'Extramedullary plasmacytoma (Multiple myeloma)',
    cro_49201: 'Rheumatic heart disease',
    cro_49202: 'Rheumatic mitral valve diseases (Rheumatic heart disease)',
    cro_49203: 'Rheumatic fever with heart involvement (Rheumatic heart disease)',
    cro_49204: 'Rheumatic aortic valve diseases (Rheumatic heart disease)',
    cro_49205: 'Rheumatic tricuspid valve diseases (Rheumatic heart disease)',
    cro_49206: 'Multiple valve diseases (Rheumatic heart disease)',
    cro_50901: 'Chronic obstructive pulmonary disease',
    cro_50902: 'Simple chronic bronchitis (Chronic obstructive pulmonary disease)',
    cro_50903: 'Mucopurulent chronic bronchitis (Chronic obstructive pulmonary disease)',
    cro_50904: 'Unilateral pulmonary emphysema (Chronic obstructive pulmonary disease)',
    cro_50905: 'Panlobular emphysema (Chronic obstructive pulmonary disease)',
    cro_50906: 'Other and unspecified emphysema (Chronic obstructive pulmonary disease)',
    cro_50907:
        'Chronic obstructive pulmonary disease with (acute) lower respiratory infection (Chronic obstructive pulmonary disease)',
    cro_50908:
        'Chronic obstructive pulmonary disease with (acute) exacerbation (Chronic obstructive pulmonary disease)',
    cro_50909:
        'Other and unspecified chronic obstructive pulmonary disease (Chronic obstructive pulmonary disease)',
    cro_50910: 'Unspecified bronchitis (Chronic obstructive pulmonary disease)',
    cro_50911:
        'Mixed simple and mucopurulent chronic bronchitis (Chronic obstructive pulmonary disease)',
    cro_50912: 'Centrilobular emphysema (Chronic obstructive pulmonary disease)',
    cro_51601: 'Interstitial lung disease and pulmonary sarcoidosis',
    cro_51602:
        'Respiratory bronchiolitis interstitial lung disease (Interstitial lung disease and pulmonary sarcoidosis)',
    cro_51603:
        'Cryptogenic organizing pneumonia (Interstitial lung disease and pulmonary sarcoidosis)',
    cro_51604:
        'Alveolar and parieto-alveolar conditions (Interstitial lung disease and pulmonary sarcoidosis)',
    cro_51605: 'Sarcoidosis (Interstitial lung disease and pulmonary sarcoidosis)',
    cro_51606: 'Pulmonary fibrosis (Interstitial lung disease and pulmonary sarcoidosis)',
    cro_51607:
        'Idiopathic pulmonary fibrosis (Interstitial lung disease and pulmonary sarcoidosis)',
    cro_51608: 'Other and unspecified ILD (Interstitial lung disease and pulmonary sarcoidosis)',
    cro_54301: "Alzheimer's disease and other dementias",
    cro_54302: "Alzheimer's disease (Alzheimer's disease and other dementias)",
    cro_54303: "Frontotemporal dementia (Alzheimer's disease and other dementias)",
    cro_54304: "Vascular dementia (Alzheimer's disease and other dementias)",
    cro_54305: "Leukodystrophy (Alzheimer's disease and other dementias)",
    cro_54306: "Alper's Disease (Alzheimer's disease and other dementias)",
    cro_54307: "Leigh's Disease (Alzheimer's disease and other dementias)",
    cro_54308: "Alexander disease (Alzheimer's disease and other dementias)",
    cro_54309:
        "Degeneration of nervous system due to alcohol (Alzheimer's disease and other dementias)",
    cro_54310: "Other dementias (Alzheimer's disease and other dementias)",
    cro_54311: "Lewy Body (Alzheimer's disease and other dementias)",
    cro_54312: "Corticobasal degeneration (Alzheimer's disease and other dementias)",
    cro_54401: "Parkinson's disease",
    cro_54402: "Unspecified Parkinson's disease (Parkinson's disease)",
    cro_54403: "Parkinson's disease with dyskinesia (Parkinson's disease)",
    cro_54404: "Parkinson's disease without dyskinesia (Parkinson's disease)",
    cro_55401: 'Motor neuron disease',
    cro_55402: 'Aymotrophic lateral sclerosis (Motor neuron disease)',
    cro_55403: 'Primary lateral sclerosis (Motor neuron disease)',
    cro_55404: 'Progressive bulbar palsy (Motor neuron disease)',
    cro_55405: 'Other motor neuron disease (Motor neuron disease)',
    cro_55406: 'Progressive spinal muscular atrophy (Motor neuron disease)',
    cro_55407: 'Spinal muscular atrophy (Motor neuron disease)',
    cro_55408: 'Familial motor neuron disease (Motor neuron disease)',
    cro_55409: 'Spinal muscular atrophy, unspecified (Motor neuron disease)',
    cro_55410: 'Other spinal muscular atrophies and related syndromes (Motor neuron disease)',
    cro_57101: 'Anxiety disorders',
    cro_57102: 'Other, unspecified, and generalized anxiety (Anxiety disorders)',
    cro_57103: 'Obsessive-compulsive disorder (Anxiety disorders)',
    cro_57104: 'Panic disorders (Anxiety disorders)',
    cro_57105: 'Post-traumatic stress disorder (Anxiety disorders)',
    cro_58801: 'Acute glomerulonephritis',
    cro_58802: 'Rapidly progressive nephritic syndrome (Acute glomerulonephritis)',
    cro_58803: 'Acute nephritic syndrome (Acute glomerulonephritis)',
    cro_58901: 'Chronic kidney disease',
    cro_58902: 'Anemia in chronic kidney disease (Chronic kidney disease)',
    cro_58903: 'Chronic kidney disease due to diabetes (Chronic kidney disease)',
    cro_58904: 'Congential kidney conditions (Chronic kidney disease)',
    cro_58905: 'Cystic Kidney Disease (Chronic kidney disease)',
    cro_58906: 'Hypertensive chronic kidney disease (Chronic kidney disease)',
    cro_58907: 'IgA (Chronic kidney disease)',
    cro_58908: 'Other chronic kidney disease (Chronic kidney disease)',
    cro_58909: 'Primary membranous nephropathy (Chronic kidney disease)',
    cro_58910: 'Recurrent and persistent hematuria (Chronic kidney disease)',
    cro_58911: 'Renal agenesis and other reduction defects of kidney (Chronic kidney disease)',
    cro_62701: 'Rheumatoid arthritis',
    cro_62702: "Felty's syndrome (Rheumatoid arthritis)",
    cro_62703: 'Rheumatoid lung disease with rheumatoid arthritis (Rheumatoid arthritis)',
    cro_62704: 'Rheumatoid vasculitis with rheumatoid arthritis (Rheumatoid arthritis)',
    cro_62705: 'Rheumatoid heart disease with rheumatoid arthritis (Rheumatoid arthritis)',
    cro_62706: 'Rheumatoid polyneuropathy with rheumatoid arthritis (Rheumatoid arthritis)',
    cro_62707:
        'Rheumatoid arthritis with involvement of other organs and systems (Rheumatoid arthritis)',
    cro_62708:
        'Rheumatoid arthritis with rheumatoid factor without organ or systems involvement (Rheumatoid arthritis)',
    cro_62709: 'Pauciarticular juvenile rheumatoid arthritis (Rheumatoid arthritis)',
    cro_62710: 'Juvenile rheumatoid polyarthritis (seronegative) (Rheumatoid arthritis)',
    cro_62711: 'Juvenile rheumatoid arthritis with systemic onset (Rheumatoid arthritis)',
    cro_62712: 'Other and unspecified rheumatoid arthritis (Rheumatoid arthritis)',
    cro_62713: 'Unspecified juvenile rheumatoid arthritis (Rheumatoid arthritis)',
    cro_62714: 'Inflammatory polyarthropathy (Rheumatoid arthritis)',
    cro_62715: "Adult-onset Still's disease (Rheumatoid arthritis)",
    cro_62716: 'Juvenile ankylosing spondylitis (Rheumatoid arthritis)',
    cro_62717: 'Rheumatoid myopathy with rheumatoid arthritis (Rheumatoid arthritis)',
    cro_66401: 'Urticaria',
    cro_66402: 'Allergic urticaria (Urticaria)',
    cro_66403: 'Idiopathic urticaria (Urticaria)',
    cro_66404: 'Urticaria due to cold and heat (Urticaria)',
    cro_66405: 'Dermatographic urticaria (Urticaria)',
    cro_66406: 'Vibratory urticaria (Urticaria)',
    cro_66407: 'Cholinergic urticaria (Urticaria)',
    cro_66408: 'Contact urticaria (Urticaria)',
    cro_66409: 'Other and unspecified urticaria (Urticaria)',
    cro_67201: 'Age-related macular degeneration',
    cro_67202: 'Cystoid macular degeneration (Age-related macular degeneration)',
    cro_67203: 'Macular cyst, hole, or pseudohole (Age-related macular degeneration)',
    cro_67204: 'Drusen (degenerative) of macula (Age-related macular degeneration)',
    cro_67205: 'Puckering of macula (Age-related macular degeneration)',
    cro_67206: 'Other and unspecified macular degeneration (Age-related macular degeneration)',
    cro_67207: 'Exudative age-related macular degeneration (Age-related macular degeneration)',
    cro_67208: 'Non-exudative age-related macular degeneration (Age-related macular degeneration)',
    cro_84701: 'Acute myeloid leukemia',
    cro_84702: 'Acute monoblastic/monocytic leukemia (Acute myeloid leukemia)',
    cro_84703: 'Acute myeloblastic leukemia (Acute myeloid leukemia)',
    cro_84704: 'Acute myelomonocytic leukemia (Acute myeloid leukemia)',
    cro_84705: 'Acute promyelocytic leukemia (Acute myeloid leukemia)',
    cro_84706: 'Myeloid sarcoma (Acute myeloid leukemia)',
    cro_84707: 'Other acute myeloid leukemia (Acute myeloid leukemia)',
    cro_84801: 'Chronic myeloid leukemia, BCR/ABL-positive (Chronic myeloid leukemia)',
    cro_84802: 'Atypical chronic myeloid leukemia, BCR/ABL-negative (Chronic myeloid leukemia)',
    cro_84803: 'Chronic myeloid leukemia',
    cro_96401: 'Myelodysplastic, myeloproliferative, and other hematopoietic neoplasms',
    cro_96402:
        'Polycythemia vera (Myelodysplastic, myeloproliferative, and other hematopoietic neoplasms)',
    cro_96403:
        'Myelodysplastic syndromes (Myelodysplastic, myeloproliferative, and other hematopoietic neoplasms)',
    cro_96404:
        'Chronic myeloproliferative disease (Myelodysplastic, myeloproliferative, and other hematopoietic neoplasms)',
    cro_96405:
        'Essential (hemorrhagic) thrombocythemia (Myelodysplastic, myeloproliferative, and other hematopoietic neoplasms)',
    cro_96406:
        'Mast cell neoplasms of uncertain behavior (Myelodysplastic, myeloproliferative, and other hematopoietic neoplasms)',
    cro_96407:
        'Other and unspecified myelodysplastic, myeloproliferative, and hematopoietic neoplasms (Myelodysplastic, myeloproliferative, and other hematopoietic neoplasms)',
    cro_96408:
        'Monoclonal gammopathy (Myelodysplastic, myeloproliferative, and other hematopoietic neoplasms)',
    cro_96801: 'Non-rheumatic calcific aortic valve disease',
    cro_96802: 'Nonrheumatic aortic (valve) stenosis (Non-rheumatic calcific aortic valve disease)',
    cro_96803:
        'Nonrheumatic aortic (valve) insufficiency (Non-rheumatic calcific aortic valve disease)',
    cro_96804:
        'Nonrheumatic aortic (valve) stenosis with insufficiency (Non-rheumatic calcific aortic valve disease)',
    cro_96805:
        'Unspecified and other nonrheumatic aortic valve disorders (Non-rheumatic calcific aortic valve disease)',
    cro_96806:
        'Other and unspecified nonrheumatic mitral valve disorders (Non-rheumatic degenerative mitral valve disease)',
    cro_96807:
        'Nonrheumatic mitral (valve) stenosis (Non-rheumatic degenerative mitral valve disease)',
    cro_96808:
        'Nonrheumatic mitral (valve) prolapse (Non-rheumatic degenerative mitral valve disease)',
    cro_96809:
        'Nonrheumatic mitral (valve) insufficiency (Non-rheumatic degenerative mitral valve disease)',
    cro_96810: 'Non-rheumatic degenerative mitral valve disease',
    cro_100801: 'Eye cancer',
    cro_100802: 'Malignant neoplasm of choroid (Eye cancer)',
    cro_100803: 'Malignant neoplasm of ciliary body (Eye cancer)',
    cro_100804: 'Malignant neoplasm of cornea (Eye cancer)',
    cro_100805: 'Malignant neoplasm of orbit (Eye cancer)',
    cro_100806: 'Malignant neoplasm of retina (Eye cancer)',
    cro_100807: 'Other and unspecified malignanat eye cancers (Eye cancer)',
    cro_114301: 'Myasthenia gravis',
    cro_999901: 'Autoimmune hepatitis',
    cro_999902: 'Dermatitis due to ingested food',
    cro_999903: 'Duchenne or Becker muscular dystrophy',
    cro_999904: 'Egg allergy',
    cro_999905: 'Giant cell arteritis with polymyalgia rheumatica',
    cro_999906: 'Glomerular disease in systemic lupus erythenatosus',
    cro_999907: 'Glomerular disorders in diseases classified elsewhere',
    cro_999908: 'Hereditary motor and sensory neuropathy',
    cro_999909: 'Hidradenitis suppurativa',
    cro_999910: "Huntington's disease",
    cro_999911: 'Lymphangioma, any site',
    cro_999912: 'Myelofibrosis',
    cro_999913: 'Myositis',
    cro_999914: 'Other autoimmune hemolytic anemias',
    cro_999915: 'Peanut allergy',
    cro_999916: 'Polymyalgia rheumatica',
    cro_999917: 'Shellfish allergy',
    cro_999918: 'Sjögren syndrome',
    cro_999919: 'Spinal muscular atrophy and related syndromes',
    cro_999920: 'Systemic lupus erythematosus (SLE)',
    cro_999921: 'Systemic lupus erythematosus, organ or system involvement unspecified',
    cro_999922: 'Systemic sclerosis [scleroderma]',
    cro_999923: 'Vasculitis limited to skin, not elsewhere classified',
};
